import { connect } from 'react-redux';
import idx from 'idx';
import {
  submitUserSurveyRequest, submitCsSurveyRequest, createTestimonialRequest, fetchWrapupsIfNeeded,
  getWrapups, isFeedbackSubmitted
} from 'project/ducks/wrapup';
import { fetchProject } from 'project/ducks/project';
import Survey from 'project/components/wrapup/survey';

const mapStateToProps = (state, { wrapup, isCreative }) => {
  const ratedCs = !!getWrapups(state).find(w => w.cs_survey_submitted_at);
  /* show CS survey if user is the client and hasn't rated CS yet for this project */
  const showCsSurvey = !isCreative && !ratedCs;
  const alreadySubmitted = isFeedbackSubmitted(wrapup, state.user.profile_data);

  return {
    showCsSurvey,
    alreadySubmitted,
    values: idx(state.form, _ => _.WrapupSurvey.values) || {}
  };
};

export default connect(mapStateToProps, {
  submitUserSurveyRequest,
  submitCsSurveyRequest,
  createTestimonialRequest,
  fetchWrapupsIfNeeded,
  fetchProject,
})(Survey);



// WEBPACK FOOTER //
// ./project/containers/wrapup/survey.js